import React from "react";
import step2 from "./assets/step2.png";
import step3 from "./assets/step3.png";
import step4 from "./assets/step4.png";
import step5 from "./assets/step5.png";
import step6 from "./assets/step6.png";
import step7 from "./assets/step7.png";

import Header from './components/Header';
import './Dashboard.css';
import { SignIn, Show, SignOutButton, PricingTable, UserProfile, useAuth } from '@clerk/react'

function Dashboard() {
  const [selectedNav, setSelectedNav] = React.useState('getting-started');
  const { has } = useAuth();
  const hasPaidPlan = typeof has === 'function' ? !has({ plan: 'free_user' }) : false;
  return (
    <>
      <Header />
      <Show when="signed-out">
        <div className="dashboard-container">
          <div className="dashboard-placeholder">
            <SignIn forceRedirectUrl="/dashboard" />
          </div>
        </div>
      </Show>
      <Show when="signed-in">
        <div className="dashboard-main-layout">
          <nav className="dashboard-sidebar">
            <div className="dashboard-sidebar-inner">
              <ul>
                <li className={selectedNav === 'getting-started' ? 'active' : ''} onClick={() => setSelectedNav('getting-started')}>Chrome Extension</li>
                <li className={selectedNav === 'subscription' ? 'active' : ''} onClick={() => setSelectedNav('subscription')}>Subscription</li>
                <li className={selectedNav === 'support' ? 'active' : ''} onClick={() => setSelectedNav('support')}>Support</li>
                <li className={selectedNav === 'profile' ? 'active' : ''} onClick={() => setSelectedNav('profile')}>Profile</li>
              </ul>
              <div className="dashboard-signout-sidebar-row">
                <SignOutButton className="dashboard-signout-btn">Sign Out</SignOutButton>
              </div>
            </div>
          </nav>
          <main className="dashboard-main-content">
            <section className="dashboard-card" style={{ textAlign: selectedNav === 'profile' ? 'left' : undefined }}>
              {selectedNav === 'support' && (
                <div style={{ textAlign: 'left', width: '100%' }}>
                  <h1 className="dashboard-title" style={{ textAlign: 'left', fontSize: '2rem', fontWeight: 700, marginBottom: 28, color: '#1a233a', marginLeft: 0 }}>
                    Support is just an email away
                  </h1>
                  <p style={{ fontSize: '1.08rem', color: '#6b7280', textAlign: 'left', marginLeft: 0 }}>
                    For support, contact: <a href="mailto:david@bidderiq.com" style={{ color: '#32C5FF', textDecoration: 'underline' }}>david@bidderiq.com</a>
                  </p>
                </div>
              )}
              {selectedNav === 'profile' && (
                <div style={{ width: '100%', textAlign: 'left' }}>
                  <h1 className="dashboard-title" style={{ fontSize: '2rem', fontWeight: 700, marginBottom: 28, color: '#1a233a', marginLeft: 0, textAlign: 'left', display: 'inline-block' }}>
                    Manage Your Profile
                  </h1>
                </div>
              )}
              {selectedNav !== 'getting-started' && selectedNav !== 'subscription' && selectedNav !== 'support' && selectedNav !== 'profile' && (
                <h1 className="dashboard-title">Welcome to Your Dashboard</h1>
              )}
              {selectedNav === 'subscription' && (
                <h1 className="dashboard-title" style={{ textAlign: 'left', fontSize: '2rem', fontWeight: 700, marginBottom: 28, color: '#1a233a' }}>
                  {hasPaidPlan
                    ? 'Current Subscription'
                    : 'For more data, such as auction Estimate and Previous Listings, subscribe below'}
                </h1>
              )}
<div className="dashboard-content">
                {selectedNav === 'getting-started' && (
  <>
    <div style={{ marginBottom: '32px', width: '100%' }}>
      <div
        style={{
          position: 'relative',
          paddingBottom: '64.7482%',
          height: 0,
          overflow: 'hidden',
          borderRadius: '18px',
          boxShadow: '0 2px 12px rgba(30,40,60,0.09)',
        }}
      >
        <iframe
          src="https://www.loom.com/embed/c11905436b0a49ea9481e4abea759b9c?sid=cc1246e3-bd0e-4032-bbd3-eb2aa7d0ef80"
          frameBorder="0"
          allowFullScreen
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%'
          }}
          title="How to Install Bidder IQ"
        ></iframe>
      </div>
    </div>
    <h1 className="dashboard-title" style={{ marginBottom: 18, textAlign: 'left', width: '100%' }}>
      How to Install the Chrome Extension
    </h1>
    <div style={{ fontSize: '1.22rem', fontWeight: 500, marginBottom: 18, textAlign: 'left', width: '100%' }}>
      1. Click the Blue <strong>"Download Chrome Extension"</strong> button below, a new window will open the Bidder iQ Google Chrome Webstore page
    </div>
    <a
      href="https://chromewebstore.google.com/detail/bidder-iq/nheiffajgnplomenmolhgfcmnkgdmjgm"
      className="dashboard-download-link"
      target="_blank"
      rel="noopener noreferrer"
    >
      <span className="dashboard-download-icon" aria-hidden="true">
        {/* SVG download icon */}
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="11" cy="11" r="11" fill="#32C5FF" />
          <path d="M11 6v7m0 0l-3-3m3 3l3-3" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
      Download Chrome Extension
    </a>
    <div style={{ marginTop: 48, width: '100%' }}>
      <div style={{ fontSize: '1.22rem', fontWeight: 500, textAlign: 'left' }}>
        2. Once on the Bidder iQ Chrome Webstore page, click the Blue <strong>"Add to Chrome"</strong> button.
      </div>
      <div style={{ marginTop: 12, textAlign: 'left' }}>
        <img src={step2} alt="Step 2: Add to Chrome" style={{ width: '100%', borderRadius: 12, boxShadow: '0 1px 6px rgba(30,40,60,0.10)' }} />
      </div>
    </div>
    <div style={{ marginTop: 48, width: '100%' }}>
      <div style={{ fontSize: '1.22rem', fontWeight: 500, textAlign: 'left' }}>
        3. On the confirmation pop-up, click <strong>"Add extension."</strong>
      </div>
      <div style={{ marginTop: 12, textAlign: 'left' }}>
        <img src={step3} alt="Step 3: Add extension confirmation" style={{ maxWidth: 420, width: '100%', borderRadius: 12, boxShadow: '0 1px 6px rgba(30,40,60,0.10)' }} />
      </div>
    </div>
    <div style={{ marginTop: 48, width: '100%' }}>
      <div style={{ fontSize: '1.22rem', fontWeight: 500, textAlign: 'left' }}>
        4. On the righthand side of the url bar, click the icon that looks like a puzzle piece
      </div>
      <div style={{ marginTop: 12, textAlign: 'left' }}>
        <img src={step4} alt="Step 4: Puzzle piece icon" style={{ width: '100%', borderRadius: 12, boxShadow: '0 1px 6px rgba(30,40,60,0.10)' }} />
      </div>
    </div>
    <div style={{ marginTop: 48, width: '100%' }}>
      <div style={{ fontSize: '1.22rem', fontWeight: 500, textAlign: 'left' }}>
        5. On the dropdown, click the icon that looks like a pin to pin the extension to your window.
      </div>
      <div style={{ marginTop: 12, textAlign: 'left' }}>
        <img src={step5} alt="Step 5: Pin extension" style={{ maxWidth: 420, width: '100%', borderRadius: 12, boxShadow: '0 1px 6px rgba(30,40,60,0.10)' }} />
      </div>
    </div>
    <div style={{ marginTop: 48, width: '100%' }}>
      <div style={{ fontSize: '1.22rem', fontWeight: 500, textAlign: 'left' }}>
        6. Click the Blue Bidder iQ icon and sign in to your account
      </div>
      <div style={{ marginTop: 12, textAlign: 'left' }}>
        <img src={step6} alt="Step 6: Click Bidder iQ icon and sign in" style={{ maxWidth: 420, width: '100%', borderRadius: 12, boxShadow: '0 1px 6px rgba(30,40,60,0.10)' }} />
      </div>
    </div>
    <div style={{ marginTop: 48, width: '100%' }}>
      <div style={{ fontSize: '1.22rem', fontWeight: 500, textAlign: 'left' }}>
        7. Navigate to a Live Porsche Auction on one of the supported auction websites, you should see data. If not, refresh and/or sign out and then sign in again
      </div>
      <div style={{ marginTop: 12, textAlign: 'left' }}>
        <img src={step7} alt="Step 7: See data on supported auction site" style={{ width: '100%', borderRadius: 12, boxShadow: '0 1px 6px rgba(30,40,60,0.10)' }} />
      </div>
    </div>
    <div style={{ marginTop: 48, width: '100%' }}>
      <div style={{ fontSize: '1.22rem', fontWeight: 500, textAlign: 'left' }}>
        8. For more data, such as <strong>Estimate</strong> and <strong>Previous Listings</strong>, subscribe below
      </div>
      <div style={{ marginTop: 28 }}>
        <PricingTable />
      </div>
    </div>
                  </>
                )}
                {selectedNav === 'subscription' && (
                  <div style={{ width: '100%' }}>
                    <PricingTable />
                  </div>
                )}

                {selectedNav === 'profile' && (
                  <div style={{ marginTop: '32px', width: '100%' }}>
                    <UserProfile />
                  </div>
                )}
              </div>
            </section>
          </main>
        </div>
      </Show>
    </>
  );
}

export default Dashboard;
